/**
 * @fileOverview Cheap workaround for adding client support via Zendesk chat
 * This loads the Zendesk script if the user is the client.
 */

import { withRouter } from 'react-router-dom'

var isLoaded = false

const ZendeskLoader = props => {
  ;(async () => {
    if (isLoaded) return
    var user = await localStorage.getItem('user')
    try {
      user = JSON.parse(user)
    } catch (err) {
      return
    }
    if (!user) return
    if (user.role != 'ROLE_CLIENT' && user.role != 'CLIENT_ADMIN') return

    var script = document.createElement('script')
    script.type = 'text/javascript'
    script.id = 'ze-snippet'
    script.src =
      'https://static.zdassets.com/ekr/snippet.js?key=7832e89f-2126-45f3-b6bf-6de10110e353'
    document.body.appendChild(script)
    isLoaded = true
  })()
  return props.children
}

export default withRouter(ZendeskLoader)
